<template>
    <div v-if="loggedIn && isDebug && $route.path == '/menu'">
        <pre>{{ { tikklok, userLocation } }}</pre>
    </div>
</template>
<style scoped>
div {
    max-width: 300px;
    float: right;
    margin-right: 30px;
}
</style>
<script>
import { mapActions, mapGetters } from 'vuex';
import IsDebugMixin from '../mixins/is-debug';
export default {
    mixins: [IsDebugMixin],
    computed: {
        ...mapGetters({
            tikklok: 'currentUser/getTikklok',
            userLocation: 'currentUser/getUserLocation',
            loggedIn: 'currentUser/isValidLogin',
        }),
    },
};
</script>
